import Game from '../../../classes/Game';
import { Box } from '@chakra-ui/react';
import { withGame } from '../helpers';

import Inventory from './Inventory';
import Shop from './Shop'


function GameMenu({ game }: { game: Game }) {

  return <Box>
    <Box position="absolute" p={2} bottom={0} left={0} zIndex={1}>
      <Inventory game={game}/>
    </Box>
    <Box position="absolute" p={2} bottom={0} right={0} zIndex={1}>
      <Shop game={game} />
    </Box>
  </Box>
}

export default withGame(GameMenu)


